export enum TypeLayout {
    Default = "default", // Sin paneles
    Personal = "personal",  // Sin Panel preguntas y respuestas
    Advisor = "advisor", // 2 Paneles
    Conversation = "conversation", // Panel izquierdo / subir PDF
    Channel = "channel" // Canales solo en INCA
  }
  export enum TypeEnvironment {
    Dev = "dev", 
    Prod = "prod"
  }


export enum MessageType {
  Bot = 'bot',
  User = 'user',
  Alert = 'alert',
  Warning = 'warning',
  Welcome = 'welcome',
  TimeOut = 'timeOut'
}

export enum AccessType { 
    LogIn="LogIn",
    Incognito="Incognito"
}
export enum AccessTypeForm { 
    Providers="providers",
    User="user",
    Generic = "generic"
}



export enum DomainUser { 
    CasaAndina = "casa-andina.com" 
  }

export enum PanelLayout {
  Left = "left" ,
  Right = "right" 
}
   

export enum ModeLayout {
    Edit = "edit" ,
    View = "view",
    Published = "published"
}
  
export enum TypeFile {
  Qa = "CHATBOT_QA" ,
  Pdf = "CHATBOT_PDF",
  Excel = "CHATBOT_EXCEL",
  Docs = "CHATBOT_DOCS",
  //Index = "CHATBOT_INDEX" ,

}



export enum StatusFile {
  Created= "CREATED",
  Done = "DONE",
  Error = "ERROR"
}

export enum OriginFile {
   Device = "device",
   Drive = "google_drive"
}



export const FormatExtensions: Record<TypeLayout, string[]> = {
  [TypeLayout.Default]: [],
  [TypeLayout.Personal]: [".pdf"],
  [TypeLayout.Advisor]: [".pdf", ".xls", ".xlsx"],
  [TypeLayout.Conversation]: [".pdf", ".xls", ".xlsx"],
  [TypeLayout.Channel]: [],
};

export const getTypeLayoutLabel = (type: string): string => {
  const labels: Record<TypeLayout, string> = {
    [TypeLayout.Default]: "Predeterminado",
    [TypeLayout.Personal]: "Personal",
    [TypeLayout.Advisor]: "Asesor",
    [TypeLayout.Conversation]: "Conversación",
    [TypeLayout.Channel]: "Canal",
  };
  return labels[type as TypeLayout] || "Desconocido";
};

export enum IntegrationType {
  Whatsapp = "WHATSAPP",
  Azure_bot = "AZURE_BOT",  
  Supplier = "SUPPLIER",
  Embed= "EMBED"
  //Playground = "PLAYGROUND", 
} 
export const getIntegrationType = (type: string): string => {
  const labels: Record<IntegrationType, string> = {
    [IntegrationType.Whatsapp]: "Whatsapp",
    [IntegrationType.Azure_bot]: "Azure Bot",    
    [IntegrationType.Supplier]: "Proveedor",
    [IntegrationType.Embed]: "Página Web(Incrustado)"
    //[IntegrationType.Playground]: "Playground", 
  }; 
  return labels[type as IntegrationType] || "Desconocido";
};

export const integrationOrder: Record<string, number> = {
  [IntegrationType.Whatsapp]: 1,
  [IntegrationType.Azure_bot]: 2,
  [IntegrationType.Supplier]: 3,
  [IntegrationType.Embed]: 4,
};

 

export enum AlertType {
  Success = "success",
  Warning = "warning",
  Error = "error",
  Info = "info",
}

export enum DataCenterDoc{
  chunk_overlap = 1500,
  chunk_size = 5000,
}

export enum Action {
  LOGIN_ANONYMOUS_IDENTIFIER = "AC000010",

  LEFT_FORM_DINAMICO = "AC000100",
  LEFT_FORM_ENVIO = "AC000200",
  LEFT_FUENTE = "AC000300",

  LEFT_MY_DOC = "AC000400",
  LEFT_MY_DOC_ADD = "AC000500",
  LEFT_MY_DOC_ADD_FILE = "AC000510",
  LEFT_MY_DOC_ADD_NAME = "AC000520",
  LEFT_MY_DOC_ADD_DESCRIPTION = "AC000530",
  LEFT_MY_DOC_ADD_CANCEL = "AC000540", 
  LEFT_MY_DOC_ADD_SAVE = "AC000550",
  LEFT_MY_DOC_ADD_CLOSE = "AC000560",
  LEFT_MY_DOC_MENU = "AC000600",
  LEFT_MY_DOC_EDIT = "AC000700",
  LEFT_MY_DOC_DOWNLOAD = "AC000800",
  LEFT_MY_DOC_DELETE = "AC000900",

  LEFT_CONVERSATION_ADD = "AC000950", // add --
  LEFT_CONVERSATION_ADD_NAME = "AC00051", // add --
  LEFT_CONVERSATION_ADD_DESCRIPTION  = "AC00052", // add --
  LEFT_CONVERSATION_ADD_SAVE = "AC00053", // add --
  LEFT_CONVERSATION_ADD_CANCEL = "AC00054", // add --
  LEFT_CONVERSATION_SELECT = "AC00055", // add --

  LEFT_CONVERSATION_EDIT = "AC000951", // add --
  LEFT_CONVERSATION_CLOSE = "AC000952", // add --

  CENTER_CONFIG_AGENTE_BOT = "AC001000",
  
  CENTER_CONFIG_AGENTE_NAME = "AC001100",
  CENTER_CONFIG_AGENTE_ROL = "AC001200",
  CENTER_CONFIG_AGENTE_COMPANIA = "AC001300",
  CENTER_CONFIG_AGENTE_COMPANIA_ACTVIDAD = "AC001350",
  CENTER_CONFIG_AGENTE_PROPOSITO = "AC001400",

  CENTER_CONFIG_AVANZADO_TEMPERATURE = "AC001500",
  CENTER_CONFIG_AVANZADO_RETRIVAL = "AC001600",
  CENTER_CONFIG_AVANZADO_TOKEN = "AC001700",
  CENTER_CONFIG_AVANZADO_TOP = "AC001800",
  CENTER_CONFIG_CLOSE = "AC001900", //
  CENTER_CONFIG_SAVE = "AC002000",
  
  CENTER_MSG_CITATION = "AC002100",
  CENTER_MSG_RESET = "AC002150",
  CENTER_MSG_CHAT = "AC002200",
  CENTER_MSG_SENT = "AC002250",
  CENTER_FUENTE_CHAT = "AC002260",
  CENTER_CONVERSATION_VIEW = "AC002265",// add 
  CENTER_CONVERSATION_ADD = "AC002266",// add 
  CENTER_ATTACH_FILE = "AC002270",// add 

  RIGHT_SEARCH = "AC002300",
  RIGHT_SEARCH_LINK = "AC002400",
  NOTIFICATION_LINK = "AC002500",
  

  

  



  
  

}

/*
export const getAction = (type: string): string => {
  const labels: Record<Action, string> = {
    [Action.LEFT_FORM_DINAMICO]: "Formulario dinámico" ,
    [Action.LEFT_FORM_DINAMICO]: "Formulario dinámico" ,
    [Action.LEFT_FORM_DINAMICO]: "Formulario dinámico" ,
    [Action.LEFT_FORM_DINAMICO]: "Formulario dinámico" ,
  }; 
  return labels[type as Action] || "Desconocido";
};*/

export enum QuotaUserStatus {
  New = "new",
  Existing = "existing",
  Updated = "updated",
  Deleted = "deleted",
}

 



export const LOCAL_ICON_COLOR: Record<TypeFile, string> = {
  [TypeFile.Pdf]: "text-red-400",
  [TypeFile.Excel]: "text-green-400",
  [TypeFile.Docs]: "text-blue-400",
  [TypeFile.Qa]: "text-purple-400",
  //[TypeFile.Index]: "text-yellow-600",
};  